import './Section.scss'


const Section = () => {
  return (
    <section className='main-section'>
      <div className="content">
        <h1>Be Warm, Merry and Stand Out</h1>
        <button>Discover</button>
      </div>
      <div className="bottom">
        <p>10% off for all products</p>
      </div>
    </section>
  )
}

export default Section